import React, {useEffect, useState} from 'react';
import { Styles } from '../../../config/design/styles';
import { withStyles } from "@mui/styles";
import { connect } from "trim-redux";
import {useNavigate,Link} from "react-router-dom";
import axios from "axios";
import {defaultVariables} from "../../../config";
import AppAnimate from "../../components/AppAnimate";
import Grid from "@mui/material/Grid2";
import AdminDashSkeleton from "../../components/loaders/AdminDashSkeleton";
import {useTranslation} from "react-i18next";
import {Box, IconButton, Typography} from "@mui/material";
import {CircleArrowRight, ClipboardList, CreditCard, Eye, MessageCircle, MoveRight, Store} from "lucide-react";
import {currencySymbol, price} from "../../../config/values";
import OrdersAlert from "../orders/components/OrdersAlert";
import { LineChart } from '@mui/x-charts/LineChart';
import moment from "moment";
import SwiperSlider from "../../components/elements/slider/SwiperSlider";
import ProductCard from "../supplier/products/components/ProductCard";
import SubTitle from "../../components/elements/SubTitle";

const AdminDashboard = ({ classes,user }) => {
    const { t } = useTranslation();
    const [loading,setLoading] = useState(true);
    const [data,setData] = useState([]);
    const navigation = useNavigate();
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/dashboards/get-admin`,config)
            .then(response => {
                setData(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        // Fetch match data when component mounts
        loadData();
    }, []);
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('dashboard')}>
            <Grid container spacing={2} justify="center" className="dashboard">
                {
                    loading ?
                        <AdminDashSkeleton/>
                        :
                        <>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/panel/manage/orders'>
                                    <ClipboardList className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item">{t('ongoing_orders')}</span>
                                    <strong style={{fontSize:20}}>{data.ongoing_orders}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/panel/manage/shops/view-all'>
                                    <Store className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item"> {t('pending_shops')}</span>
                                    <strong style={{fontSize:20}}>{data.pending_shops}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/panel/manage/wallets/view-all'>
                                    <CreditCard className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item"> {t('pending_transactions')}</span>
                                    <strong style={{fontSize:20}}>{data.pending_transactions}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:6,sm:6,md:3,lg:3}} className={classes.cardPending}>
                                <Box className="bg-red-box bg-item-dashboard p-15 flex-direction flex-column" component={Link} to='/panel/manage/comments/view-all'>
                                    <MessageCircle className="lucide-icon-primary lucide-xl"/>
                                    <span className="title-item"> {t('pending_comments')}</span>
                                    <strong style={{fontSize:20}}>{data.pending_comments}</strong>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:12,sm:6,md:6,lg:3}}>
                                <Box className="bg-gray-box">
                                    <div className="flex-space">
                                        <strong>{t('orders')}</strong>
                                        <IconButton
                                            size="small"
                                            variant="outlined"
                                            component={Link}
                                            to='/panel/manage/orders'
                                        >
                                            <CircleArrowRight className="lucide-icon-gray"/>
                                        </IconButton>
                                    </div>
                                    <hr className="mb-15 mt-5"/>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('today')}</Typography>
                                        <strong>{data.today_orders}</strong>
                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('yesterday')}</Typography>
                                        <strong>{data.analytics.yesterday_orders}</strong>
                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('this_month')}</Typography>
                                        <strong>{data.analytics.this_month_orders}</strong>
                                    </div>

                                    <div className="flex-space mb-10">
                                        <strong className="secondary">{t('total')}</strong>
                                        <strong className="secondary">{data.analytics.total_orders}</strong>
                                    </div>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:12,sm:6,md:6,lg:3}}>
                                <Box className="bg-gray-box">
                                    <div className="flex-space">
                                        <strong>{t('sales')}</strong>
                                        <IconButton
                                            size="small"
                                            variant="outlined"
                                            component={Link}
                                            to='/panel/manage/orders'
                                        >
                                            <CircleArrowRight className="lucide-icon-gray"/>
                                        </IconButton>
                                    </div>
                                    <hr className="mb-15 mt-5"/>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('today')}</Typography>
                                        <strong>{price(data.today_sales)} {currencySymbol}</strong>
                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('yesterday')}</Typography>
                                        <strong>{price(data.analytics.yesterday_sales)} {currencySymbol}</strong>

                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('this_month')}</Typography>
                                        <strong>{price(data.analytics.this_month_sales)} {currencySymbol}</strong>

                                    </div>

                                    <div className="flex-space mb-10">
                                        <strong className="secondary">{t('total')}</strong>
                                        <strong className="secondary">{price(data.analytics.total_sales)} {currencySymbol}</strong>
                                    </div>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:12,sm:6,md:6,lg:3}}>
                                <Box className="bg-gray-box">
                                    <div className="flex-space">
                                        <strong>{t('commissions')}</strong>
                                        <IconButton
                                            size="small"
                                            variant="outlined"
                                            component={Link}
                                            to='/panel/manage/orders'
                                        >
                                            <CircleArrowRight className="lucide-icon-gray"/>
                                        </IconButton>
                                    </div>
                                    <hr className="mb-15 mt-5"/>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('today')}</Typography>
                                        <strong>{price(data.today_commission)} {currencySymbol}</strong>

                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('yesterday')}</Typography>
                                        <strong>{price(data.analytics.yesterday_commission)} {currencySymbol}</strong>

                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('this_month')}</Typography>
                                        <strong>{price(data.analytics.this_month_commission)} {currencySymbol}</strong>

                                    </div>

                                    <div className="flex-space mb-10">
                                        <strong className="secondary">{t('total')}</strong>
                                        <strong className="secondary">{price(data.analytics.total_commission)} {currencySymbol}</strong>

                                    </div>
                                </Box>
                            </Grid>
                            <Grid item size={{xs:12,sm:6,md:6,lg:3}}>
                                <Box className="bg-gray-box">
                                    <div className="flex-space">
                                        <strong>{t('users')}</strong>
                                        <IconButton
                                            size="small"
                                            variant="outlined"
                                            component={Link}
                                            to='/panel/manage/users/view-all'
                                        >
                                            <CircleArrowRight className="lucide-icon-gray"/>
                                        </IconButton>
                                    </div>
                                    <hr className="mb-15 mt-5"/>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('today')}</Typography>
                                        <strong>{data.today_users}</strong>
                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('yesterday')}</Typography>
                                        <strong>{data.analytics.yesterday_users}</strong>
                                    </div>
                                    <div className="flex-space mb-10">
                                        <Typography>{t('this_month')}</Typography>
                                        <strong>{data.analytics.this_month_users}</strong>
                                    </div>

                                    <div className="flex-space mb-10">
                                        <strong className="secondary">{t('total')}</strong>
                                        <strong className="secondary">{data.analytics.total_users}</strong>
                                    </div>
                                </Box>
                            </Grid>

                            <Grid item size={12}>
                                <LineChart
                                    dataset={data.chart_orders.map(item => ({
                                        x: moment(item.x).format("MMM D"),
                                        y: item.y
                                    }))}
                                    xAxis={[{ dataKey: "x", scaleType: "band", label: "Days" }]}
                                    yAxis={[{
                                        // Add this yAxis configuration
                                        valueFormatter: (value) => Math.floor(value).toString(), // Rounds down and converts to string
                                        tickMinStep: 1 // Ensures ticks only show whole numbers
                                    }]}
                                    series={[{ dataKey: "y", label: "Orders",color: "#F0051F" }]}
                                    height={300}
                                    margin={{ left: 30, right: 30, top: 30, bottom: 50 }}
                                    grid={{ vertical: true, horizontal: true }}
                                />
                            </Grid>
                            {
                                !!data.order_alerts?.length &&
                                <Grid item size={12} className="my-10">
                                    <SubTitle className="dialog-title" align="left">{t('OrdersError')}</SubTitle>
                                </Grid>
                            }

                            <Grid item size={12}>
                                <OrdersAlert alerts={!!data.order_alerts ? data.order_alerts : []} dashboard/>
                            </Grid>
                            <Grid item size={12} className="my-10">
                                <SubTitle className="dialog-title" align="left">{t('mostSellingProducts')}</SubTitle>
                            </Grid>
                                <Grid item size={12}>
                                <Grid container spacing={2}>
                                    {
                                        data.most_selling_products.map((item,index) => (
                                            <Grid item size={{xs:6,sm:4,md:4,lg:2}} key={index}>
                                                <ProductCard dashboard item={item} reload={() => loadData()}/>
                                            </Grid>
                                        ))
                                    }
                                </Grid>

                            </Grid>
                        </>


                }
            </Grid>
        </AppAnimate>

    );
};

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
});

export default withStyles(Styles)(connect(mstp)(AdminDashboard));
